import { MessageType } from '../models/sms';
import kingSlizeLocations from '../../../environments/kingslize_locations.json';

export function buildMessageText(
    message: MessageType,
    branchId: string,
    branchName: string,
    options?: { etaMinutes?: number; address?: string }
): string {
    const branch = kingSlizeLocations.find(loc => loc.branchId === branchId);
    if (!branch) throw new Error(`Unknown branch with: ${branchName}`);
    const phone = branch.phone;
    const eta = options?.etaMinutes ?? 5;
    const address = options?.address;

    switch (message) {
        case MessageType.CourierWaiting:
            return `Beste klant,\nIk ben met uw bestelling aangekomen op het adres: ${address}.  \nMet vriendelijke groet,\nKingslize ${branchName}\nTel: ${phone}`;

        case MessageType.ArrivingSoon:
            const addressLine = address ? ` op het opgegeven adres: ${address}` : '';
            return `Beste klant,\nIk ben momenteel onderweg met uw bestelling en verwacht binnen ${eta} minuten aan te komen${addressLine}.\nMet vriendelijke groet,\nKingslize ${branchName}\nTel: ${phone}`;

        case MessageType.Delayed:
            return `Beste klant,\nUw bestelling zal met een vertraging van ongeveer ${eta} minuten worden geleverd.\nOnze oprechte excuses voor het ongemak.\nMet vriendelijke groet,\nKingslize ${branchName}\nTel: ${phone}`;

        default:
            throw new Error('Unsupported message type');
    }
}
